module.exports = __webpack_public_path__ + "img/3_x3.a25ae6e2.png";